import ServiceLanding from "@/pages/ServiceLanding";
import { Container, Package, PackageOpen, HardHat } from "lucide-react";

const page = {
  slug: "skip-bins",
  path: "/skip-bins",
  crumb: "Skip Bins",
  eyebrow: "Skip Bin Hire · Melbourne",
  serviceType: "Skip Bin Hire",
  metaTitle: "Skip Bin Hire Melbourne | Site Cleanup Melbourne",
  metaDesc:
    "Need a skip bin in Melbourne? Site Cleanup matches you with local skip bin suppliers across Epping, Craigieburn, Wollert, Tarneit, Werribee & more. Free quotes.",
  h1: "Skip Bin Hire Across Melbourne",
  intro:
    "Need a skip bin in Melbourne? Site Cleanup connects you with vetted local skip bin suppliers across the northern and western growth corridors — Epping, Craigieburn, Wollert, Donnybrook, Mernda, Tarneit, Clyde and Werribee. We offer six industry-standard sizes: 2m³, 3m³, 4m³, 6m³, 8m³ and 10m³, covering everything from a single-room clean-out to a full builder's site strip. Loads accepted include general household waste, green waste (prunings, grass, leaves), soil and clean fill, and mixed construction waste (bricks, tiles, plasterboard, timber). We can't take asbestos, liquids, tyres, batteries, gas bottles or hazardous materials. Every quote is GST-inclusive with a transparent 7-day standard hire and clear extra-day fees. Just tell us your address, size and waste type — we'll come back with a firm written quote from a matched local operator within one business day.",
  cta: "Get a Free Skip Bin Quote",
  cardsTitle: "Skip bin categories we quote on",
  cardsSub: "Six industry-standard sizes covering household clean-outs, renovation debris and builder waste — pick the size that fits your job and we'll do the rest.",
  cards: [
    { title: "Mini Skip (2m³ – 4m³)", icon: Container, desc: "Perfect for a single-room clean-out, garage tidy or small garden waste job. Roughly 15–30 wheelie bins of capacity." },
    { title: "Medium Skip (6m³ – 8m³)", icon: Package, desc: "Whole-house declutters, full room renos, mid-size builder waste. Fits around 45–60 wheelie bins." },
    { title: "Large Skip (10m³+)", icon: PackageOpen, desc: "Large-scale house strip-outs, small vacant lot clean-ups, commercial site waste. Roughly 75 wheelie bins of capacity." },
    { title: "Construction Skip", icon: HardHat, desc: "Heavy-duty bins for concrete, bricks, tiles, plasterboard, timber offcuts and mixed builder waste — during or post-build." },
  ],
  step3: "Skip delivered",
  step3d: "Operator delivers the skip to your address, usually within 1–2 business days of accepting the quote. Standard 7-day hire, extra days available.",
  faqTitle: "Skip bin questions we hear a lot",
  faq: [
    {
      q: "What size skip bin do I need?",
      a: "It depends on the job size. A 2m³ mini suits a single-room clean-out or garage tidy; a 4–6m³ covers most renovations; and an 8–10m³ handles builder waste and full-house strip-outs. We'll recommend the right size when you request your quote.",
    },
    {
      q: "What can I put in a skip bin?",
      a: "General waste, green waste, soil and clean fill, concrete, bricks, and mixed construction waste are all accepted. We can't take asbestos, liquid waste, tyres, batteries, gas bottles or hazardous materials.",
    },
    {
      q: "How long can I keep the skip bin?",
      a: "Standard hire is 7 days from delivery. If you need longer, extensions are available at $50–$75/day depending on size and location — just tell us when you book.",
    },
    {
      q: "Do you service my suburb?",
      a: "We cover Epping, Craigieburn, Wollert, Donnybrook, Mernda, Tarneit, Clyde, Werribee and surrounding Melbourne growth-corridor suburbs. Ask us if your suburb isn't listed — we're constantly adding new operators.",
    },
    {
      q: "How quickly can a skip be delivered?",
      a: "Usually within 1–2 business days after quote approval. Same-day delivery is often possible in Melbourne metro suburbs if the request comes in before 10am.",
    },
  ],
  finalTitle: "Free Melbourne skip bin quote.",
  finalSub: "Send us your address, preferred size and waste type. We'll come back within one business day with a matched local operator and a firm written quote — GST included.",
};

export default function SkipBinsPage() {
  return <ServiceLanding page={page} />;
}
